/** Staff Hub API client — cookie auth. */
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
const ax = axios.create({ baseURL: BACKEND_URL, withCredentials: true });
const u = (p) => p.then((r) => r.data);

export const staffApi = {
  colleagues:   ()                       => u(ax.get('/api/staff/colleagues')),
  unreadCount:  ()                       => u(ax.get('/api/staff/unread-count')),
  list:         (params)                 => u(ax.get('/api/staff/messages', { params })),
  thread:       (tid)                    => u(ax.get(`/api/staff/messages/${tid}`)),
  send:         (body)                   => u(ax.post('/api/staff/messages', body)),
  reply:        (tid, body)              => u(ax.post(`/api/staff/messages/${tid}/reply`, { body })),
  pin:          (mid, pinned)            => u(ax.post(`/api/staff/messages/${mid}/pin`, { pinned })),
  remove:       (mid)                    => u(ax.delete(`/api/staff/messages/${mid}`)),
};

export default staffApi;
